module.exports = __webpack_public_path__ + "img/3_u.19e2fed4.jpg";